import { formatCalendarEventDisplayTitle } from '@/app/(main)/calendar/utils/formatCalendarEventDisplayTitle';
import type { CalendarEvent } from '@/types/calendarTypes';

type GroupedBirthday = Pick<CalendarEvent, 'type' | 'title'>;

type FormatGroupedBirthdayLabelOptions = {
  countOnly?: boolean;
};

function getBirthdayFirstName(event: GroupedBirthday): string {
  const displayTitle = formatCalendarEventDisplayTitle(event).trim();
  const [firstName] = displayTitle.split(/\s+/);
  return firstName || displayTitle;
}

export function formatGroupedBirthdayLabel(
  birthdays: GroupedBirthday[],
  { countOnly = false }: FormatGroupedBirthdayLabelOptions = {}
): string {
  if (birthdays.length === 0) return '';

  if (countOnly) return String(birthdays.length);

  const firstName = getBirthdayFirstName(birthdays[0]);
  if (birthdays.length === 1) return firstName;

  return `${firstName} +${birthdays.length - 1}`;
}

export function formatBirthdaysAriaLabel(birthdays: GroupedBirthday[]): string {
  if (birthdays.length === 0) return '';

  const label = formatGroupedBirthdayLabel(birthdays);

  return birthdays.length === 1 ? `${label}'s birthday` : `${birthdays.length} birthdays, ${label}`;
}
